module.exports = __webpack_public_path__ + "NeueFrutigerWorld-UltLt.3986ed30898b2b18c257.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/assets/fonts/neue-frutiger-world/NeueFrutigerWorld-UltLt.ttf
// module id = ../../../../../src/assets/fonts/neue-frutiger-world/NeueFrutigerWorld-UltLt.ttf
// module chunks = styles